import React, { Fragment, useEffect, useState } from "react";
import { useLocation, Link, useHistory } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "../store/index";
import { Helmet } from "react-helmet";
import Tooltip from "./Tooltip";
import { browserHistory } from "react-router";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import useCustomloadapi from "../hooks/use-scriptload";
import { useTranslation } from "react-i18next";
const Resourcedetails = () => {
  const { t } = useTranslation("translation", { keyPrefix: "resourcedetails" });
  //useJsApiLoader()
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);  
  const [reourcedetails, setReourcedetails] = useState({});
  const [address, setAddress] = useState("");
  const [customval, setCustomval] = useState("");
  const [mapaddress, setMapaddress] = useState("");
  const [ramhours, setRamhours] = useState("");
  const [maplink, setMaplink] = useState(false);
  const [showmap, setShowmap] = useState(false);
  const [isshowotherdetails, setIsshowotherdetails] = useState(false);
  const favoritearray = useSelector((index) => index.favoritearray);
  const [activeMarker, setActiveMarker] = useState(null);
  const dispatch = useDispatch();
  const place = useSelector((index) => index.place);
  const searchBy = useSelector((index) => index.searchBy);
  const categoryId = useSelector((index) => index.categoryId);
  const subCategoryId = useSelector((index) => index.subCategoryId);
  const keyword = useSelector((index) => index.keyword);
  const [favoriteBtnText, setFavoriteBtnText] = useState(t("add_to_favorite"));
  const [locationKeys, setLocationKeys] = useState([]);
  const webLanguage = localStorage.getItem("lang");
  const handleActiveMarker = (marker) => {
    window.scrollTo(0, 0);
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const handleOnLoad = (map) => {
    const bounds = new google.maps.LatLngBounds();
    bounds.extend({
      lat: parseFloat(reourcedetails.Latitude),
      lng: parseFloat(reourcedetails.Longitude),
    });
    map.fitBounds(bounds);
  };

  const google = window.google;

  useEffect(async () => {
    //console.log(place);
    await getDetails();
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
      }

      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);

          // Handle forward event
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);

          // Handle back event
          //console.log("Back clicked!!");
          backtolisting();
        }
      }
    });
  }, [locationKeys]);

  const getDetails = async () => {
    const resourceDetailsURL = queryParams.get("id").split("_");
    const resourceID = resourceDetailsURL[0];
    const response = await axios.get(
      process.env.REACT_APP_REACT_APP_API_END_POINT +
        process.env.REACT_APP_GET_RESOURCES_BY_ID +
        resourceID +
        "?code=" +
        process.env.REACT_APP_API_KEY
    );
    //console.log(response.data);
    setReourcedetails(response.data);
    if (
      response.data.Latitude &&
      response.data.Longitude &&
      response.data.IsHelpline !== true
    )
      setShowmap(true);
    else setShowmap(false);
    //return response.data;

    const RAM = response.data;

    if (RAM.Map != "Shelter" && RAM.IsHelpline !== true) {
      if (RAM.IsHelpline != true) {
        const address = [];
        if (RAM.PhysicalAddress) {
          address.push(RAM.PhysicalAddress);
        }
        if (RAM.City) {
          address.push(RAM.City);
        }
        if (RAM.PhysicalCountry) {
          address.push(RAM.PhysicalCountry);
        }
        if (RAM.PhysicalPostalCode) {
          address.push(RAM.PhysicalPostalCode);
        }

        setAddress(address.join(", "));
        setMapaddress(
          "https://www.google.com/maps?saddr=" +
            RAM.PhysicalAddress +
            ", " +
            RAM.City +
            ", " +
            RAM.PhysicalCountry +
            ", " +
            RAM.PhysicalPostalCode
        );
        setMaplink(true);
      }
    }

    let hoursSection = "";
    if (RAM.WorkHours || RAM.HoursOfOperation) {
      hoursSection = hoursSection + "<h3>" + t("open_hours") + "</h3>";
      if (RAM.WorkHours != "") var WorkHours = RAM.WorkHours.split(";");
      if (Array.isArray(WorkHours)) {
        for (var i = 0; i < WorkHours.length; i++) {
          if (WorkHours[i] != "") {
            hoursSection =
              hoursSection +
              "<p><span>" +
              WorkHours[i].substr(0, 4).trim() +
              "</span>" +
              WorkHours[i].substr(4) +
              "</p>";
          }
        }
      }

      hoursSection = hoursSection + "<p>" + RAM.HoursOfOperation + "</p>";
    }

    setRamhours(hoursSection);

    if (
      RAM.FeeStructureSource ||
      RAM.CustomEligibilitybyAge ||
      RAM.Eligibility ||
      RAM.DisabilitiesAccess ||
      RAM.LanguagesOfferedList ||
      RAM.NormalWaitTime
    ) {
      setIsshowotherdetails(true);
    }

    window.initMap = () => {
      const myLatLng = { lat: RAM.Latitude, lng: RAM.Longitude };
      const map = new window.google.maps.Map(document.getElementById("map"), {
        center: myLatLng,
        zoom: 12,
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
        gestureHandling: "none",
        zoomControl: false,
        draggableCursor: "default",
        draggingCursor: "pointer",
      });

      new window.google.maps.Marker({
        position: myLatLng,
        map: map,
        title: RAM.Name,
        draggable: false,
      });
    };

    if (favoritearray.indexOf(RAM.ETLLoadID) === -1) {
      //console.log("In fav");
      setFavoriteBtnText(t("add_to_favorite"));
    } else {
      //console.log("Not in fav");
      setFavoriteBtnText(t("remove_from_favourites"));
    }
  };

  const backtolisting = () => {
    if (place.formatted_address.length > 0) {
      let $restUrl;
      if (searchBy === "topic") {
        $restUrl = "&category=" + categoryId + "&subcategory=" + subCategoryId;
      } else {
        $restUrl = "&keyword=" + keyword;
      }
      /*console.log(
        "?location=" + place.formatted_address + "&type=" + searchBy + $restUrl
      );*/
      history.push({
        search:
          "?location=" +
          place.formatted_address +
          "&type=" +
          searchBy +
          $restUrl,
      });
    }
    dispatch(ramactions.changestatus(0));
    dispatch(ramactions.updateApiCall(false));
    window.scrollTo(0, 0);
  };

  const clickonFavorite = () => {
    if (favoritearray.indexOf(reourcedetails.ETLLoadID) === -1) {
      const updatedfavoritearray = [...favoritearray, reourcedetails.ETLLoadID];
      dispatch(ramactions.addfavorite(updatedfavoritearray));
      //setIsShow(true);
      dispatch(ramactions.faviruteRemoved(false));
      dispatch(ramactions.faviruteAdded(true));
      // setTimeout(() => {
      //   dispatch(ramactions.faviruteAdded(false));
      // }, 4000);
      setFavoriteBtnText(t("remove_from_favourites"));
    } else {
      dispatch(
        ramactions.addfavorite(
          favoritearray.filter((item) => item != reourcedetails.ETLLoadID)
        )
      );
      //setIsShow(false);
      dispatch(ramactions.faviruteAdded(false));
      dispatch(ramactions.faviruteRemoved(true));
      // setTimeout(() => {
      //   dispatch(ramactions.faviruteRemoved(false));
      // }, 4000);
      setFavoriteBtnText(t("add_to_favorite"));
    }
  };

  const showSearchhome = () => {
    dispatch(ramactions.changestatus(0));
  };

  const showFavorite = () => {
    dispatch(ramactions.changestatus(2));
  };
  window.scrollTo(0, 0);
  const isFavAdded = useSelector((state) => state.isFavoriteAdded);
  const isFavRemoved = useSelector((state) => state.isFavoriteRemoved);
  useEffect(() => {
    let timer1;
    timer1 = setTimeout(() => {
      dispatch(ramactions.faviruteAdded(false));
      dispatch(ramactions.faviruteRemoved(false));
    }, 4000);

    return () => {
      clearTimeout(timer1);
    };
  }, [isFavRemoved, isFavAdded]);
  return (
    <div className="ram-resources">
      <div className="container-fluid container-fluid--1480">
        <div className="location">
          <div className="top-row d-flex justify-content-between align-items-center d-lg-none">
            <Link
              onClick={backtolisting}
              className="back-btn back-to-search-result"
              aria-label={t("back")}
              role="button"
            >
              <span className="btb bt-arrow-left"></span>
            </Link>
            <Link
              href="#favourite"
              aria-label={t("goto_fav_list")}
              className="fav-wrapper"
              to={{
                pathname: location.pathname,
                hash: "#favorites",
              }}
              onClick={showFavorite}
            >
              {(isFavAdded || isFavRemoved) && (
                <Tooltip
                  tipText={
                    isFavAdded
                      ? t("add_to_favorite_tooltip")
                      : isFavRemoved && t("removed_from_favorites_tooltip")
                  }
                ></Tooltip>
              )}
              <span className="fav-wrapper">
                <span className="bts bt-star" aria-hidden="true"></span>
                <span className="sr-only">{t("favourites")}</span>
                <span className="step details-step-mobile">
                  {favoritearray.length}
                </span>
              </span>
            </Link>
          </div>
          {showmap && (
            <div className="map-top">
              <Helmet>
                <script
                  src={
                    "https://maps.googleapis.com/maps/api/js?key=" +
                    process.env.REACT_APP_GOOGLE_MAP_API_KEY +
                    "&language=" +
                    webLanguage +
                    "&callback=initMap"
                  }
                  async
                  defer
                />
              </Helmet>
              <div style={{ height: "100%" }} id="map"></div>
            </div>
          )}
          <div className="d-none d-lg-block">
            <div className="top-row d-flex justify-content-between align-items-center">
              <Link
                onClick={backtolisting}
                className="back-btn back-to-search-result"
                aria-label={t("back")}
                role="button"
              >
                <span className="btb bt-arrow-left"></span>
              </Link>
              <Link
                href="#favourite"
                aria-label={t("goto_fav_list")}
                className="fav-wrapper"
                to={{
                  pathname: location.pathname,
                  hash: "#favorites",
                }}
                onClick={showFavorite}
              >
                {(isFavAdded || isFavRemoved) && (
                  <Tooltip
                    tipText={
                      isFavAdded
                        ? t("add_to_favorite_tooltip")
                        : isFavRemoved && t("removed_from_favorites_tooltip")
                    }
                  ></Tooltip>
                )}
                <span className="fav-wrapper">
                  <span className="bts bt-star" aria-hidden="true"></span>
                  <span className="sr-only">{t("favourites")}</span>
                  <span className="step details-step">
                    {favoritearray.length}
                  </span>
                </span>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-sm-8 offset-sm-2">
              <div className="resources-text text-center">
                <h2 className="header-one" tabindex="0">
                  {reourcedetails.Name}
                </h2>
                {maplink && <p>{address}</p>}
                <div className=" link-wrapper d-flex justify-content-around">
                  {maplink && (
                    <span className="link">
                      <a
                        href={
                          "https://www.google.com/maps?saddr=" +
                          reourcedetails.PhysicalAddress +
                          ", " +
                          reourcedetails.City +
                          ", " +
                          reourcedetails.PhysicalCountry +
                          ", " +
                          reourcedetails.PhysicalPostalCode
                        }
                        target="_blank"
                      >
                        {t("get_directions")}
                        <span className="sr-only">{t("new_tab")}</span>
                        <span className="ext-icon" aria-hidden="true"></span>
                      </a>
                    </span>
                  )}
                  <span className="link">
                    <button
                      data-id="8584572b-b390-4ab8-96c1-864de50102ca"
                      className="save-fav add-to-favourites-details"
                      onClick={clickonFavorite}
                    >
                      <span className="bts bt-star " aria-hidden="true"></span>
                      {favoriteBtnText}
                    </button>
                  </span>
                </div>

                <div className="btn-wrapper d-flex justify-content-around">
                  {reourcedetails.Phone && reourcedetails.Phone.length > 0 && (
                    <a
                      role="button"
                      href={`tel:${reourcedetails.Phone}`}
                      className="btn btn-primary gtmClickToCall"
                      aria-label={`${t("call")} ${reourcedetails.Phone}`}
                    >
                      {reourcedetails.Phone}
                    </a>
                  )}
                  {reourcedetails.WebsiteAddress && (
                    <a
                      role="button"
                      href={reourcedetails.WebsiteAddress}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary gtmClickToVisit"
                    >
                      {" "}
                      {t("website")}{" "}
                      <span className="sr-only">{t("new_tab")}</span>
                      <span
                        className="btb bt-external-link"
                        aria-hidden="true"
                      ></span>
                    </a>
                  )}
                </div>
                <div
                  className="timings"
                  dangerouslySetInnerHTML={{ __html: ramhours }}
                ></div>
                {/*<div className="timings">
                  <h3>Open hours</h3>

                  <p>
                    <span>Mon</span>
                    9:00am - 8:00pm
                  </p>
                  <p>
                    <span>Tue</span>
                    9:00am - 8:00pm
                  </p>
                  <p>
                    <span>Wed</span>
                    9:00am - 8:00pm
                  </p>
                  <p>
                    <span>Thu</span>
                    9:00am - 8:00pm
                  </p>
                  <p>
                    <span>Fri</span>
                    9:00am - 5:00pm
                  </p>
                  </div>*/}
              </div>
            </div>
          </div>
          {/* <div>{address}</div> */}
          {/* {maplink && (
            <div>
              <a href={mapaddress} target="_blank">
                Get directions<span className="sr-only">open in a new tab</span>
                <span className="ext-icon" aria-hidden="true"></span>
              </a>
            </div>
          )} */}
          {/* {reourcedetails.Phone && <div>{reourcedetails.Phone}</div>} */}
          {/* {reourcedetails.WebsiteAddress && (
            <div>
              <a
                role="button"
                href={reourcedetails.WebsiteAddress}
                target="_blank"
                className="btn btn-primary gtmClickToVisit"
              >
                Website <span className="sr-only">open in a new tab</span>
                <span
                  className="btb bt-external-link"
                  aria-hidden="true"
                ></span>
              </a>
            </div>
          )} */}
        </div>
      </div>
      {reourcedetails.AgencyDescription && (
        <div className="about-us">
          <div className="container-fluid container-fluid--1480">
            <div className="row justify-content-center">
              <div className="col-lg-7">
                <h2>{t("about_us")}</h2>
                <p
                  dangerouslySetInnerHTML={{
                    __html: reourcedetails.AgencyDescription,
                  }}
                ></p>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="details">
        <div className="container-fluid container-fluid--1480">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              {isshowotherdetails && (
                <div>
                  <h2>{t("details")}</h2>
                  <div className="showcase">
                    <ul>
                      {reourcedetails.FeeStructureSource && (
                        <li>
                          <img
                            src={
                              "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/cost.svg"
                            }
                            alt=""
                            aria-hidden="true"
                          />
                          <span className="font-weight-bold">{t("cost")}:</span>
                          {reourcedetails.FeeStructureSource}
                        </li>
                      )}
                      {reourcedetails.CustomEligibilitybyAge && (
                        <li>
                          <img
                            src={
                              "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/age-limit.svg"
                            }
                            alt=""
                            aria-hidden="true"
                          />
                          <span className="font-weight-bold">
                            {t("age_limit")}:
                          </span>
                          {reourcedetails.CustomEligibilitybyAge.trim()}
                        </li>
                      )}
                      {reourcedetails.Eligibility && (
                        <li>
                          <img
                            src={
                              "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/eligibility.svg"
                            }
                            alt=""
                            aria-hidden="true"
                          />
                          <span className="font-weight-bold">
                            {t("eligibility")}:
                          </span>
                          {reourcedetails.Eligibility.trim()}
                        </li>
                      )}
                      {reourcedetails.DisabilitiesAccess && (
                        <li>
                          <img
                            src={
                              "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/accesibility.svg"
                            }
                            alt=""
                            aria-hidden="true"
                          />
                          <span className="font-weight-bold">
                            {t("accessibility")}:
                          </span>
                          {reourcedetails.DisabilitiesAccess.trim()}
                        </li>
                      )}
                      {reourcedetails.LanguagesOfferedList && (
                        <li>
                          <img
                            src={
                              "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/languages.svg"
                            }
                            alt=""
                            aria-hidden="true"
                          />
                          <span className="font-weight-bold">
                            {t("languages_offered")}:
                          </span>
                          {reourcedetails.LanguagesOfferedList.trim()}
                        </li>
                      )}
                      {reourcedetails.NormalWaitTime && (
                        <li>
                          <img
                            src={
                              "/wp-content/mu-plugins/ram2/ramsearchapp/src/assets/images/wait-times.svg"
                            }
                            alt=""
                            aria-hidden="true"
                          />
                          <span className="font-weight-bold">
                            {t("wait_times")}:
                          </span>
                          {reourcedetails.NormalWaitTime.trim()}
                        </li>
                      )}
                    </ul>
                  </div>
                  {reourcedetails.ApplicationProcess && (
                    <Fragment>
                      <h3 className="header-four">
                        {t("application_process")}
                      </h3>
                      <p>{reourcedetails.ApplicationProcess}</p>
                    </Fragment>
                  )}
                  {reourcedetails.DocumentsRequired && (
                    <Fragment>
                      <h3 className="header-four">{t("documents_required")}</h3>
                      <p>{reourcedetails.DocumentsRequired}</p>
                    </Fragment>
                  )}
                  {reourcedetails.Coverage && (
                    <Fragment>
                      <h3 className="header-four">{t("coverage_area")}</h3>
                      <p>{reourcedetails.Coverage}</p>
                    </Fragment>
                  )}
                  <p>{reourcedetails.CoverageArea}</p>
                  <div className="row">
                    {reourcedetails.Phone && (
                      <div className="col-md-6 col-lg-5">
                        <a
                          role="button"
                          href={`tel:${reourcedetails.Phone}`}
                          className="btn btn-primary gtmClickToCall"
                          aria-label={`${t("call")} ${reourcedetails.Phone}`}
                        >
                          {reourcedetails.Phone}
                        </a>
                      </div>
                    )}
                    {reourcedetails.WebsiteAddress && (
                      <div className="col-md-6 col-lg-5">
                        <a
                          role="button"
                          href={reourcedetails.WebsiteAddress}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-primary gtmClickToVisit"
                        >
                          {t("visit_website")}
                          <span className="sr-only">{t("new_tab")}</span>
                          <span
                            className="btb bt-external-link"
                            aria-hidden="true"
                          ></span>
                        </a>
                      </div>
                    )}

                    <div className="col-lg-10">
                      <p className="text-center back-search-link back-to-search-result">
                        <Link role="button" onClick={backtolisting}>
                          <span
                            className="btb bt-arrow-left"
                            aria-hidden="true"
                          ></span>
                          {t("back_to_search_results")}
                        </Link>
                      </p>
                    </div>
                  </div>
                  {/* {reourcedetails.Phone && <div>{reourcedetails.Phone}</div>} */}
                  {/* {reourcedetails.WebsiteAddress && (
                    <div>
                      <Link
                        role="button"
                        href={reourcedetails.WebsiteAddress}
                        target="_blank"
                        className="btn btn-primary gtmClickToVisit"
                      >
                        Website{" "}
                        <span className="sr-only">open in a new tab</span>
                        <span
                          className="btb bt-external-link"
                          aria-hidden="true"
                        ></span>
                      </Link>
                    </div>
                  )} */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resourcedetails;
